import * as React from 'react';
import cx from 'classnames';
import CancelIcon from '@mui/icons-material/Cancel';
import InputAdornment from '@mui/material/InputAdornment';
import OutlinedInput from '@mui/material/OutlinedInput';

const styles = require('./styles.pcss');

type Props = {
  onChange: any;
  margin?: any;
  value: any;
  onClear: any;
  disabled?: any;
  error?: any;
  fullWidth?: any;
  className?: any;
  inputComponent?: any;
  id?: any;
  name?: any;
  type?: any;
  label?: string;
  inputProps?: any;
};

const TextFieldWithClear = (props: Props) => {
  let className = styles.outlinedInputClear;

  if (props.className) {
    className = cx(styles.outlinedInputClear, props.className);
  }

  const renderAdornment = (props: Props) => {
    if (props.value.trim() !== '') {
      return (
        <InputAdornment
          className={styles.close}
          position="end"
          onClick={props.onClear}
          disablePointerEvents={props.disabled}
        >
          <CancelIcon className={styles.icon} />
        </InputAdornment>
      );
    }
  
    return null;
  };

  return (
    <OutlinedInput
      disabled={props.disabled}
      onChange={props.onChange}
      error={props.error}
      margin={props.margin}
      value={props.value}
      fullWidth={props.fullWidth}
      className={`${styles.myCustomOutlinedInput} ${className}`}
      name={props.name}
      id={props.id}
      inputComponent={props.inputComponent}
      inputProps={props.inputProps}
      endAdornment={renderAdornment(props)}
      type={props.type ? props.type : 'text'}
      label={props.label}
    />
  );
};

export default TextFieldWithClear;
